import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 600px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding-bottom: 8px;
`;

export const Content = styled.div`
  background: #fff;
  width: 100%;
`;

export const Loader = styled.div`
  margin-top: 24px;
`;

const highlightStyle = css`
  & strong {
    color: ${Palette.Primary._500};
    font-weight: inherit;
  }
`;

// export const SearchInput = styled.input`
//     color: ${() => Palette.PrimaryGray._900};
//     font-weight: normal;
//     font-size: 14px;
//     line-height: 20px;
//     border: 1px solid ${() => Palette.PrimaryGray._200};
//     border-top-color: transparent;
//     background: #fff;
//     padding: 6px 48px;
//     width: 100%;
//     &:focus {
//         outline: none;
//     }
//     &::placeholder {
//         color: ${() => Palette.PrimaryGray._400};
//         font-weight: normal;
//         font-size: 14px;
//         line-height: 20px;
//     }
// `;

export const SearchIconWrapper = styled.div`
  display: inline-flex;
  ${({ isFocusable }) =>
    isFocusable &&
    css`
      border-bottom-color: ${() => Palette.Primary._300};
    `}
  svg {
    fill: ${({ isFocusable }) => (isFocusable ? Palette.Primary._400 : Palette.PrimaryGray._400)};
  }
`;

export const SearchInputWrapper = styled.div`
  width: 100%;
  position: relative;
  ${SearchIconWrapper} {
    position: absolute;
    color: blue;
    left: 25px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const ClearSearchInputWrapper = styled.div`
  visibility: ${({ visible }) => (!visible ? 'hidden' : 'visible')};
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  cursor: pointer;
  border-radius: 4px;
  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    fill: ${() => Palette.PrimaryGray._400};
  }
  &:hover {
    svg {
      fill: ${() => Palette.PrimaryGray._500};
    }
    background: ${() => Palette.PrimaryGray._100};
  }
  &:active {
    svg {
      fill: ${() => Palette.Primary._500};
    }
    background: ${() => Palette.Primary._000};
  }
`;

export const SearchResult = styled.div`
  height: 410px;
  display: flex;
  flex-direction: column;
  padding: 4px 24px;
  overflow-y: auto;
`;

export const EmptySearchResult = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 32px;
  font-weight: 400;
  font-size: 0.75em;
  line-height: 1em;
  color: ${Palette.PrimaryGray._700};
`;

export const Item = styled.div`
  ${highlightStyle}
  color: ${Palette.PrimaryGray._700};
  font-weight: 400;
  font-size: 0.875em;
  line-height: 1.25em;
  padding: 6px;
  margin-top: 8px;
  border: 1px solid #ffffff;
  height: 36px;
  display: flex;
  align-items: center;
  &:hover {
    background: ${Palette.PrimaryGray._100};
    border: 1px solid #ffffff;
    border-radius: 4px;
    cursor: pointer;
  }
  &:active {
    background: ${Palette.Primary._000};
    border: 1px solid ${Palette.Primary._300};
    border-radius: 4px;
  }
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Row = styled.div`
  &:hover {
    background: ${Palette.PrimaryGray._100};
  }
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  padding-left: 24px;
  width: 100%;
  height: 36px;
  /* margin-top: 8px;
    margin-bottom: 8px; */
`;

export const GroupName = styled.label`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
  ${highlightStyle}
  margin-left: 8px;
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const Error = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 32px;
  font-weight: 400;
  font-size: 0.75em;
  line-height: 1em;
  color: ${Palette.PrimaryGray._700};
`;
